import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QuarterlyReport } from '../models/inspection/quarterly-report.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class InspectionQuarterlyService extends RequestService<QuarterlyReport> {
  static PATH = '/inspection/quarterly';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, InspectionQuarterlyService.PATH, globalService.debugUrl);
  }
}
